import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service'; import { UserService } from 'src/app/angularJS/services/user/user.service'; import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service'; import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service'; import { JourneyService } from 'src/app/angularJS/services/journey/journey.service'; import { CustomerService } from 'src/app/angularJS/services/customer/customer.service'; import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service'; import { PaymentService } from 'src/app/angularJS/services/payments/payments.service'; import { UsageEventService } from 'src/app/angularJS/services/usage-event/usage-event.service'; import { DialogService } from 'src/app/angularJS/services/dialog/dialog.service'; import { UsageEventCorrectionsService } from 'src/app/angularJS/services/usage-event-corrections/usage-event-corrections.service'; import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ChargeAccountBaseComponent } from '../charge-account-base.component';
import { SecureUsageTokenService } from 'src/app/angularJS/services/secure-usage-token/secure-usage-token.service';

/**
 * Class containing properties and methods for displaying product usage on a charge account
 */
export class ChargeAccountJourneysController extends ChargeAccountBaseComponent {
  public static $inject = [
    'chargeAccount',
    'breadcrumbService',
    'customerService',
    'ACTToolbarService',
    'userService',
    '$state',
    '$translate',
    'LinkBuilder',
    'QueryBuilder',
    'journeyService',
    'usageEventService',
    '$rootScope',
    'PrimaryAction',
    'dialogService',
    'usageEventCorrectionsService',
    'UserMessages',
    'secureUsageTokenService'
  ];
  public paginatorData: InterACT.Interfaces.IPaginationData = {
    currentPage: 0,
    perPageCount: 15,
    totalCount: 0
  };

  public journeys: Array<InterACT.Interfaces.Journeys.Journey> = [];
  public expandedItem: InterACT.Interfaces.Journeys.Journey;
  public journeyToUsageEventDictionary: InterACT.Interfaces.IDictionary<Array<InterACT.Interfaces.UsageEvents.UsageEvent>> = {};
  public customer: InterACT.Interfaces.Customers.Customer;
  public usageEventCorrection: InterACT.Interfaces.UsageEventCorrectionService.UsageEventCorrection;
  private secureUsageToken: InterACT.Interfaces.SecureUsageTokens.SecureUsageToken;

  constructor(
    public chargeAccount: InterACT.Interfaces.ChargeAccounts.ChargeAccount,
    public breadcrumbService: BreadcrumbService,
    public customerService: CustomerService,
    public ACTToolbarService: ACTToolbarService,
    public userService: UserService,
    public $state: ng.ui.IStateService,
    public $translate: ng.translate.ITranslateService,
    private linkBuilder: LinkBuilder,
    private queryBuilder: QueryBuilder,
    private journeyService: JourneyService,
    private usageEventService: UsageEventService,
    private $rootScope: InterACT.Interfaces.IActoraRootScope,
    private PrimaryAction: any,
    private dialogService: DialogService,
    private usageEventCorrectionsService: UsageEventCorrectionsService,
    private userMessagesService: UserMessagesService,
    private secureUsageTokenService: SecureUsageTokenService,
  ) {
    super(chargeAccount, breadcrumbService, customerService, ACTToolbarService, userService, $state, $translate);
    this.activate();
  }

  /**
   * A method that is used to check if the user's charge account has any usage tokens or secure usage tokens
   */
  public shouldShowCreateButton(): Promise<boolean> {
    return new Promise(resolve => {
      const query = this.queryBuilder
        .newParam()
        .statusIs('VALID')
        .and()
        .fieldIs('chargeAccount.link', `/charge-accounts/${ this.chargeAccount.id }`)
        .sortBy([ { columnName: 'expiry', direction: 'desc' } ])
        .getParam();

      this.secureUsageTokenService.getSecureUsageTokens(1, 1, query).then(secureUsageTokenResponse => {
        if (secureUsageTokenResponse[ 0 ] && secureUsageTokenResponse[ 0 ].secureUsageToken !== undefined) {
          this.secureUsageToken = secureUsageTokenResponse[ 0 ].secureUsageToken;

          return resolve(true);
        }

        return resolve(this.chargeAccount.usageTokens.length > 0);
      });
    });
  }

  /**
   * A method that gets the mode of a given journey
   * @param journey the journey to get the mode for
   */
  public getJourneyMode(journey: InterACT.Interfaces.Journeys.Journey) {
    if (!journey.journeyLegs || journey.journeyLegs.length === 0) {
      return 'NA';
    }

    const firstJourneyLegMode = journey.journeyLegs[ 0 ].mode;
    const otherModes = journey.journeyLegs.filter((journeyLeg) => {
      return journeyLeg.mode !== firstJourneyLegMode;
    });

    return otherModes.length > 0 ? 'MULTIPLE' : firstJourneyLegMode;
  }

  /**
   * A method that toggles the expansion state for the supplied journey
   * @param journey the journey to toggle the expansion for
   */
  public toggleExpansion = (journey: InterACT.Interfaces.Journeys.Journey) => {
    if (this.expandedItem === journey) {
      this.expandedItem = undefined;
    } else {
      this.expandedItem = journey;
      this.populateJourneyToUsageEventDictionary(journey);
    }
  }

  /**
   * A method that retrieves a given page of journeys
   * @param page the page of journeys to retrieve
   * @param perPage the amount of journeys to retrieve per page
   */
  public getData(page: number, perPage: number) {
    if (!perPage) {
      perPage = this.paginatorData.perPageCount;
    }

    const query = this.queryBuilder.newParam().fieldIs('chargeAccount.link', '/charge-accounts/' + this.chargeAccount.id)
      .sortBy([ {
        columnName: 'startDateTime',
        direction: 'desc'
      } ]).getParam();

    this.$rootScope.showSpinner = true;
    this.journeyService.getList(page, perPage, query).then((getJourneysResponse: InterACT.Interfaces.Journeys.JourneysResponse) => {
      this.paginatorData.totalCount = getJourneysResponse.meta.totalCount;
      this.journeys = getJourneysResponse.journeys;
      this.$rootScope.showSpinner = false;
    });
  }

  /**
   * A method that returns a type of the supplied usage event and suffixes it if was manually created
   * @param usageEvent the usageEvent to get the type for
   */
  public getUsageEventType(usageEvent: InterACT.Interfaces.UsageEvents.UsageEvent) {
    return usageEvent.generator && usageEvent.generator.deviceType && 'manual' === usageEvent.generator.deviceType.toLowerCase() ? `${ usageEvent.type } (${ this.$translate.instant("USAGE_EVENT_MANAGEMENT_DIALOG.TYPES.MANUAL") })` : usageEvent.type;
  }

  /**
   * A method that returns a description of the supplied tap event in the form LOCATION (Type). i.e. Cardiff Central (Entry)
   * @param usageEvent the usageEvent to get the description for
   */
  public getUsageDescription(usageEvent: InterACT.Interfaces.UsageEvents.UsageEvent) {
    const suffix = ' (' + usageEvent.type + ')';

    if (usageEvent.location && usageEvent.destinationLocation) {
      return usageEvent.location.locationName + ' > ' + usageEvent.destinationLocation.locationName;
    }

    if (usageEvent.location) {
      return usageEvent.location.locationName + suffix;
    }

    return usageEvent.destinationLocation.locationName + suffix;
  }

  /**
   * A method that returns a direction of travel (DOT) of the supplied journey
   * @param journey the journey to get the DOT for
   */
  public getDirectionOfTravel(journey: InterACT.Interfaces.Journeys.Journey) {
    if (journey.service && journey.service.direction) {
      return 'ROUTE_DIRECTION.' + journey.service.direction;
    }
    return 'ROUTE_DIRECTION.ALL';
  };

  /**
   * A method that will spawn a dialog to manage a usage event
   * It should make a call to the dialog service to open the usage event management dialog
   */
  public manageUsageEvent = (usageEvent?) => {
    const isEdit: boolean = usageEvent ? true : false;
    usageEvent = isEdit ? usageEvent : this.getBlankUsageEvent();

    this.getNumberOfUsageEventCorrectionsInTheLast28Days().then((correctionCount) => {
      this.dialogService.showUsageEventManagementDialog(usageEvent, correctionCount).then(() => {

        if (usageEvent.destinationLocation && !usageEvent.destinationLocation.link) {
          delete usageEvent.destinationLocation;
        }
        if (usageEvent.location && !usageEvent.location.link) {
          delete usageEvent.location;
        }

        if (usageEvent.type !== 'COMPLETE') {
          delete usageEvent.destinationLocation;
        }

        usageEvent.chargeAccount = {
          link: `/charge-accounts/${ this.chargeAccount.id }`
        };

        this.usageEventCorrection = {
          scheme: {
            link: this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id),
            abbreviation: this.userService.selectedScheme.reference
          },
          status: 'PENDING',
          type: isEdit ? 'EDIT' : 'ADD',
          customer: this.chargeAccount.customer,
          usageEvent: usageEvent,
          usageEventLink: isEdit ? this.linkBuilder.getUsageEventLink(usageEvent.id) : undefined
        }

        if (isEdit) {
          this.usageEventCorrectionsService.save(this.usageEventCorrection).then(() => {
            this.userMessagesService.showToast('USAGE_EVENT_MANAGEMENT_DIALOG.EDIT_USAGE_EVENT_TOAST');
          });
        } else {
          this.usageEventCorrectionsService.save(this.usageEventCorrection).then(() => {
            this.userMessagesService.showToast('USAGE_EVENT_MANAGEMENT_DIALOG.NEW_USAGE_EVENT_TOAST');
          });
        }
      });
    });
  };

  public deleteUsageEvent = (usageEvent: InterACT.Interfaces.UsageEvents.UsageEvent) => {
    this.getNumberOfUsageEventCorrectionsInTheLast28Days().then((correctionCount) => {

      this.userMessagesService.buildConfirmDialog(
        'USAGE_EVENT_MANAGEMENT_DIALOG.DELETE_USAGE_EVENT_TITLE',
        'USAGE_EVENT_MANAGEMENT_DIALOG.DELETE_USAGE_EVENT',
        { correctionCount: correctionCount },
        'CONFIRM_ADHOC_REFUND_DIALOG.CONFIRM',
        'CONFIRM_ADHOC_REFUND_DIALOG.CANCEL_BUTTON'
      ).then(() => {
        this.usageEventCorrection = {
          scheme: {
            link: this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id),
            abbreviation: this.userService.selectedScheme.reference
          },
          status: "PENDING",
          type: "DELETE",
          customer: this.chargeAccount.customer,
          usageEventLink: this.linkBuilder.getUsageEventLink(usageEvent.id)
        }
        this.usageEventCorrectionsService.save(this.usageEventCorrection).then(() => {
          this.userMessagesService.showToast('USAGE_EVENT_MANAGEMENT_DIALOG.DELETE_TOAST');
        });
      });
    });
  };

  private getNumberOfUsageEventCorrectionsInTheLast28Days() {
    const now = new Date();
    const startDate = new Date();
    startDate.setDate(now.getDate() - 28);

    const query = this.queryBuilder.newParam()
      .fieldIs('customer.link', this.chargeAccount.customer.link)
      .and()
      .openSubQuery()
      .isLessThan('created', `'${ now.toISOString() }'`)
      .and()
      .isGreaterOrEqualTo('created', `'${ startDate.toISOString() }'`)
      .closeSubQuery()
      .getParam();

    return this.usageEventCorrectionsService.getList(1, 1, query).then((response) => {
      return response.meta.totalCount;
    });
  }

  private getBlankUsageEvent() {
    return {
      scheme: {
        link: this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id),
        abbreviation: this.userService.selectedScheme.reference
      },
      status: "VALIDATED",
      timestamp: undefined,
      mode: undefined,
      type: "UNKNOWN",
      token: {
        link: this.chargeAccount.usageTokens[ 0 ] ? this.chargeAccount.usageTokens[ 0 ].link : '/secure-usage-tokens/' + this.secureUsageToken.id,
        type: this.chargeAccount.usageTokens[ 0 ] ? this.chargeAccount.usageTokens[ 0 ].tokenType : 'SECURE_USAGE_TOKEN',
      },
      location: {
        locationName: undefined,
        link: undefined
      },
      destinationLocation: {
        locationName: undefined,
        link: undefined
      },
      direction: undefined,
      operator: {
        reference: undefined,
        name: undefined,
        link: undefined
      },
      serviceDetail: {
        reference: undefined
      }
    };
  }

  /**
   * A method that retrieves, and stores in a dictionary, the usage events related to a journey
   * @param journey the journey to get and store the usage events for
   */
  private populateJourneyToUsageEventDictionary(journey: InterACT.Interfaces.Journeys.Journey) {
    if (!journey.usageEvents || journey.usageEvents.length === 0) {
      return;
    }

    if (this.journeyToUsageEventDictionary[ journey.id ]) {
      return;
    }

    const usageEventIds = journey.usageEvents.map((usageEvent) => {
      return usageEvent.link.split('/').pop();
    });

    const query = this.queryBuilder.newParam().fieldIn('id', usageEventIds).sortBy([ {
      columnName: 'timestamp',
      direction: 'desc'
    } ]).getParam();
    this.usageEventService.getList(1, usageEventIds.length, query).then((response) => {
      this.journeyToUsageEventDictionary[ journey.id ] = response.usageEvents.map((usageEventWithMeta) => { return usageEventWithMeta.usageEvent; });
    });
  }

  /**
   * A method that is called during instantiation of the controller to set up its data
   */
  private async activate() {
    this.getData(1, 15);
    this.setToolbarAndBreadcrumbs('charge-account-journeys');

    try {
      const shouldShow = await this.shouldShowCreateButton();

      if (!shouldShow) {
        return;
      }

      this.PrimaryAction.setActions([ {
        name: 'CREATE_USAGE_EVENT',
        action: this.manageUsageEvent
      } ]);
    } catch (e) {
      console.log('Could not show create button');
    }
  }
}
